import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose TekRevol for <span>Web Portal Development</span>
            </h2>
            <p>
              As a leading web portal development company, TekRevol is committed
              to delivering cutting-edge solutions that drive business success.
              Our expertise, technical proficiency, and client-centric approach
              ensure that your web portal is tailored to meet your specific
              needs and exceed your expectations.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content ">
                <h4>
                  Custom-Built
                  <br /> Solutions
                </h4>
                <p>
                  Our team crafts web portals that are fully customized to your
                  business requirements. We ensure the optimal functionality and
                  user experience of each web portal we build.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Advanced Security
                  <br /> Measures
                </h4>
                <p>
                  We implement robust security protocols to protect your data.
                  Our team ensures compliance with industry standards to make
                  the system efficient against cyberattacks.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Scalable
                  <br /> Architecture
                </h4>
                <p>
                  We design web portals with scalability in mind, allowing your
                  portal to grow and adapt as your business evolves as this
                  approach will benefit you in the long term.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Comprehensive
                  <br /> Support
                </h4>
                <p>
                  Our dedicated support team offers ongoing maintenance and
                  updates to ensure your web portal remains at peak performance.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
